import { ReactNode } from "react";

export interface NavItem {
  id: string;
  icon: ReactNode;
  label: string;
  action?: () => void;
  isActive?: boolean;
  isPrimary?: boolean;
}

/**
 * Sidebar interaction mode, persisted per-user in
 * `organization_users.preferences.sidebar_nav_mode`.
 * - hover: sidebar auto-expands on hover (default). Can be fine-tuned with
 *   `sidebar_hover_enabled` (see below) to disable the auto-expand and rely
 *   on pinning instead, without leaving this mode.
 * - flyout: always compact; hovering an icon pops out its label.
 */
export type SidebarNavMode = "hover" | "flyout";

export const SIDEBAR_NAV_MODE_DEFAULT: SidebarNavMode = "hover";

/**
 * Only meaningful when `sidebar_nav_mode` is "hover". True (default): the
 * sidebar auto-expands on hover. False: hover does nothing; use the pin
 * button under the logo to expand, unpin anytime to collapse.
 */
export const SIDEBAR_HOVER_ENABLED_DEFAULT = true;

/** Default pin state when `sidebar_pinned` is absent from preferences. */
export const SIDEBAR_PINNED_DEFAULT = true;

export const SIDEBAR_NAV_MODE_OPTIONS: {
  value: SidebarNavMode;
  label: string;
  description: string;
}[] = [
  {
    value: "hover",
    label: "Auto-expand on hover",
    description:
      "Sidebar expands when you hover over it and collapses when you move away. Pin it to keep it open.",
  },
  {
    value: "flyout",
    label: "Compact with hover labels",
    description:
      "Sidebar always stays compact. Hover to see its label next to it.",
  },
];
